import { useContext, useState } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import axios from '../../axios';
import '../stylesheets/AddJournalPage.css';

export function AddJournalPage() {
    const currentYear = new Date().getFullYear();

    const [newJournal, setNewJorunal] = useState({
        'year': currentYear,
        'title': 'N',
        'url': 'tert.pdf',
        'img': 'tert.png',
        'disabled': true,
        'content': [
            { 'id': 1, 'text': '', 'page': '' },
            { 'id': 2, 'text': '', 'page': '' },
            { 'id': 3, 'text': '', 'page': '' },
            { 'id': 4, 'text': '', 'page': '' },
            { 'id': 5, 'text': '', 'page': '' },
            { 'id': 6, 'text': '', 'page': '' },
            { 'id': 7, 'text': '', 'page': '' },
            { 'id': 8, 'text': '', 'page': '' },
        ]
    });

    const { token } = useContext(AuthContext);
    const navigate = useNavigate();

    /** 
    ===========================================
    * @functions
    ===========================================
    **/

    const handleInputChange = (e) => {
        setNewJorunal({...newJournal, [e.target.name]: e.target.value});
    };

    const handleInputCheckboxChange = () => {
        const changingJournal = newJournal.disabled = !newJournal.disabled;
        setNewJorunal({ ...newJournal, disabled: changingJournal });
    };

    const handleAddContent = () => {
        const newContentItem = {
            id: newJournal.content.length + 1,
            text: '',
            page: 0
        };

        setNewJorunal(prevState => ({
            ...prevState,
            content: [...prevState.content, newContentItem],
        }));
    };

    const handleContentTextChange = (event, id) => {
        const { value } = event.target;

        setNewJorunal((prevJournal) => ({
            ...prevJournal,
            content: prevJournal.content.map((item) =>
                item.id === id ? { ...item, text: value } : item
            ),
        }));
    };

    const handleContentPageChange = (event, id) => {
        const { value } = event.target;

        setNewJorunal((prevJournal) => ({
            ...prevJournal,
            content: prevJournal.content.map((item) =>
                item.id === id ? { ...item, page: value } : item
            ),
        }));
    };

    const handleContentDelete = (id) => {
        setNewJorunal((prevJournal) => ({
            ...prevJournal,
            content: prevJournal.content.filter((item) => item.id !== id),
        }));
    };

    const submitHandler = async (event) => {
        event.preventDefault();

        if (!newJournal.disabled) {
            let emptyArray = newJournal.content = [];
            setNewJorunal({ ...newJournal, content: emptyArray });
        }

        // if any of the contents is empty, it is cleared
        const updateContent = newJournal.content.filter(item => item.text !== '');
        const updatedJournal = {...newJournal, content: updateContent};
        setNewJorunal(updatedJournal);

        try {
            await axios.post('journals/add/', updatedJournal, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            navigate('/admin');
        } catch (error) {
            alert('Տեղի ունեցավ սխալ հարցումն ուղարկելիս:');
            console.log('Error sending request.', error);
        }
    };

    return (
        <div className='AddJournalPage'>
            <h1 className='heading'>Ավելացնել նոր ամսաթերթ</h1>

            <form onSubmit={submitHandler}>
                <div className='box'>
                    <div className='form-item'>
                        <p>Տարեթիվ</p>

                        <input
                            type='number'
                            name='year'
                            value={newJournal.year}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className='form-item'>
                        <p>Վերնագիր</p>

                        <input
                            type='text'
                            name='title'
                            value={newJournal.title}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <div className='box'>
                    <div className='form-item'>
                        <p>Հասցե</p>

                        <input
                            type='text'
                            name='url'
                            value={newJournal.url}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className='form-item'>
                        <p>Նկարի հասցեն</p>

                        <input
                            type='text'
                            name='img'
                            value={newJournal.img}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>

                <div className='form-item valid'>
                    <label>
                        <span>Valid</span>

                        <input
                            type='checkbox'
                            name='disabled'
                            checked={newJournal.disabled}
                            onChange={handleInputCheckboxChange}
                        />
                    </label>
                </div>

                {/* =============== content =============== */}
                {
                    newJournal.disabled && <div className='content'>
                        <Button className='addContent' type='default' onClick={handleAddContent}>
                            Ավելացնել բովանդակություն
                        </Button>


                        {
                            newJournal.content.map((item, index) => (
                                <div key={index} className='box'>
                                    <input
                                        type='text'
                                        value={item.text}
                                        className='text-input'
                                        placeholder='Բովանդակություն'
                                        onChange={(e) => handleContentTextChange(e, item.id)}
                                    />

                                    <input
                                        type='number'
                                        value={item.page}
                                        placeholder='Էջ'
                                        className='page-input'
                                        onChange={(e) => handleContentPageChange(e, item.id)}
                                    />

                                    <Button type='primary' danger>

                                        <i
                                            className='fa solid fa-trash'
                                            onClick={() => handleContentDelete(item.id)}
                                        />
                                    </Button>
                                </div>
                            ))
                        }
                    </div>
                }

                <Button type='primary' htmlType='submit' className='addJournalBtn'>
                    Ավելացնել ամսագիրը
                </Button>
            </form>
        </div>
    )
}
